import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import "./Specifications.scss";

export const Specifications = props => {
  return (
    <dl className="specifications">
      {props.specifications.map(spec => 
        <Fragment key={spec.heading}>
          <dt>{spec.heading}</dt>
          <dd>{spec.value}</dd>
        </Fragment>,
      )}
    </dl>
  )
}

Specifications.propTypes = {
  specifications: PropTypes.arrayOf(PropTypes.shape({
    heading: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
};